export default __webpack_public_path__ + "static/media/ZingImage.6037a668.png";